import initialState from './initialState';
import { LOGOUT, LOGOUT_DONE, LOGOUT_LOADING } from '../actions/actionTypes';

const reducerLogout = (state, action) => {
  switch (action.type) {
    case LOGOUT_LOADING:
      return {
        ...state,
        loggingOut: true
      };
    case LOGOUT_DONE:
      return {
        ...state,
        loggingOut: false
      };
    default:
      return state;
  }
};

export default (state = initialState, action) => {
  if (action.type.startsWith(LOGOUT)) {
    return reducerLogout(state, action);
  } else {
    return state;
  }
};
